export default __webpack_public_path__ + "static/media/CMEW.fb4637ba.png";